export enum FirestoreCollections {
    users = 'users',
    organizations = 'userOrganizations'
}